import { render, staticRenderFns } from "./ActivitiesStats.vue?vue&type=template&id=394e25ee&scoped=true"
import script from "./ActivitiesStats.vue?vue&type=script&lang=js"
export * from "./ActivitiesStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394e25ee",
  null
  
)

export default component.exports